import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { ApiAnnouncement } from '@/lib/adapters/announcements';

interface AnnouncementsResponse {
  data: ApiAnnouncement[];
  pagination?: { page: number; limit: number; total: number; totalPages: number };
}

export function useAnnouncements() {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: () => api.get<AnnouncementsResponse>('/announcements'),
  });
}
